import { SessionInterceptor } from './session-manager.interceptor';

/* @ngInject */
export function sessionManagerConfig ($httpProvider) {

	// Register the auth interceptor
	$httpProvider.interceptors.push(function (
		$q,
		sessionManager,
		$injector: ng.auto.IInjectorService
	) {
		return {
			responseError (response) {
				return $q.reject(SessionInterceptor.responseError(response, sessionManager, $injector.get('eventService'), $injector.get('ngxRouterService')));
			}
		};
	});
}
